export interface V2TimTopicOperationResult {
    errorCode?: number;
    errorMessage?: string;
    topicID?: string;
}
